import { createActions } from "redux-actions";

const actions = createActions({
    UPDATE_LOADS: (data) => ({data}),
    GET_LOAD_INFO: (data)=>({data}),
    SAVE_Load_INFO: (data)=>({data}),
})

export const updateLoads = actions.updateLoads;
export const getLoadInfo = actions.getLoadInfo;
export const saveLoadInfo = actions.saveLoadInfo